export default __webpack_public_path__ + "static/media/pavurya8.60f24733.jpg";